import React from "react";
import { AboutMissionVision } from "@/components/sections/AboutMissionVision";
import { TeamGrid } from "@/components/sections/TeamGrid";
import { TransparencyStrip } from "@/components/sections/TransparencyStrip";
import { ImpactCounters } from "@/components/sections/ImpactCounters";
import { CTABand } from "@/components/sections/CTABand";
import { PageHeader } from "@/components/ui-blocks/PageHeader";

export default function AboutPage() {
  return (
    <main>
      <PageHeader eyebrow="About" title="Modern civic action, built on trust." lead="CAF is a non-partisan Indian non-profit committed to public awareness, transparency, and equitable development." />
      <AboutMissionVision />
      <ImpactCounters />
      <TransparencyStrip />
      <TeamGrid />
      <CTABand />
    </main>
  );
}
